import { SelectField } from "@roc/ui";
import { ICellEditor, ICellEditorParams, ICellEditorComp, ColDef } from "ag-grid-community";
import { forwardRef, useEffect, useImperativeHandle, useRef, useState } from "react";
import { makeStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles';
import { useReceivablesDashboardStore } from '../../hooks/useReceivablesDasboardStore';
import { PayableReceivablesTypes } from "../../types/types";
import { insertIf } from "@roc/feature-utils";

const useStyles = makeStyles((theme: Theme) => ({
  selectField: {
    borderRadius: '0',
    '& .MuiSelect-root': {
      paddingTop: '11px',
      paddingBottom: '11px',
      fontSize: '14px',
    },
  },
}));

export const StatusDropdownGridEditor = forwardRef<ICellEditor, ICellEditorParams>((props, ref) => {
  const { value } = props;
  const { receivablesDashboardStore } = useReceivablesDashboardStore();
  const [editableValue, setEditableValue] = useState(value);
  const inputRef = useRef<HTMLInputElement>(null);
  const classes = useStyles();

  useImperativeHandle(ref, () => ({
    getValue: () => {
      return editableValue;
    },
  }));

  useEffect(() => {
    if (inputRef.current) inputRef.current.focus();
  }, []);

  return (
    <SelectField
      options={[
        ...insertIf(PayableReceivablesTypes.PAID === value, [{ label: 'Paid', value: 'Paid' },]),
        ...insertIf(PayableReceivablesTypes.BILLED === value, [{ label: 'Billed', value: 'Billed' },]),
        ...insertIf((PayableReceivablesTypes.PENDING === value || PayableReceivablesTypes.APPROVED === value), [{ label: 'Approved', value: 'Approved' },]),
        ...insertIf(PayableReceivablesTypes.PROCESSING === value, [{ label: 'Processing', value: 'Processing' },]),
        { label: 'Pending', value: 'Pending' },
        { label: 'Reject', value: 'Rejected' },
      ]}
      testId={'foundation'}
      value={editableValue}
      onChange={async (value) => {
        await receivablesDashboardStore.performAction(props?.data?.recordId, value);
        receivablesDashboardStore.counterPartyExpenseGridStore.resetAndFetchGridData();
        setEditableValue(value);
      }}
      fullWidth
      variant="outlined"
      className={classes.selectField}
    />
  );
});
